import type { SVGProps } from "react";

/**
 * checkmark-1
 * @category Interface General
 */
export default function IconCheckmark1(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path d='M4.75 12.7768L10 19.25L19.25 4.75' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}
